/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type ProtectionSettingsController from 'uplisting-frontend/pods/protection/settings/controller';

interface IArgs {
  page: ProtectionSettingsController;
}

interface PageSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiProtectionSettingsPageComponent = templateOnly<PageSignature>();

export default UiProtectionSettingsPageComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::Settings::Page': typeof UiProtectionSettingsPageComponent;
  }
}
